module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "businessComment"
  }, [_c('el-breadcrumb', {
    staticClass: "bread-nav",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("话题PK")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("商业评论")])], 1), _vm._v(" "), _c('div', {
    staticClass: "comment-add-box"
  }, [_c('el-form', {
    ref: "addCommentForm",
    staticClass: "addCommentForm",
    attrs: {
      "model": _vm.addCommentForm,
      "rules": _vm.validateRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "创建者",
      "prop": "creater"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择创建者或输入关键字"
    },
    model: {
      value: (_vm.addCommentForm.creater),
      callback: function($$v) {
        _vm.addCommentForm.creater = $$v
      },
      expression: "addCommentForm.creater"
    }
  }, _vm._l((_vm.user.list), function(userItem) {
    return _c('el-option', {
      key: _vm.user.userId,
      attrs: {
        "label": userItem.userName,
        "value": userItem.userId
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "话题名称",
      "prop": "topicId"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择话题或输入关键字"
    },
    model: {
      value: (_vm.addCommentForm.topicId),
      callback: function($$v) {
        _vm.addCommentForm.topicId = $$v
      },
      expression: "addCommentForm.topicId"
    }
  }, _vm._l((_vm.getTopicList), function(topicItem) {
    return _c('el-option', {
      key: topicItem.topicId,
      attrs: {
        "label": topicItem.topicTitle,
        "value": topicItem.topicId
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "userName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入用户名"
    },
    model: {
      value: (_vm.addCommentForm.userName),
      callback: function($$v) {
        _vm.addCommentForm.userName = $$v
      },
      expression: "addCommentForm.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "头像地址",
      "prop": "userPortrait"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入头像地址"
    },
    model: {
      value: (_vm.addCommentForm.userPortrait),
      callback: function($$v) {
        _vm.addCommentForm.userPortrait = $$v
      },
      expression: "addCommentForm.userPortrait"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评论内容",
      "prop": "commentContent"
    }
  }, [_c('el-input', {
    attrs: {
      "autosize": {
        minRows: 2,
        maxRows: 6
      },
      "type": "textarea",
      "auto-complete": "off",
      "placeholder": "请输入评论内容"
    },
    model: {
      value: (_vm.addCommentForm.commentContent),
      callback: function($$v) {
        _vm.addCommentForm.commentContent = $$v
      },
      expression: "addCommentForm.commentContent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评论图片",
      "prop": "commentImg"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入评论图片（选填）"
    },
    model: {
      value: (_vm.addCommentForm.commentImg),
      callback: function($$v) {
        _vm.addCommentForm.commentImg = $$v
      },
      expression: "addCommentForm.commentImg"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "点赞数",
      "prop": "likeNum"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入点赞人数"
    },
    model: {
      value: (_vm.addCommentForm.likeNum),
      callback: function($$v) {
        _vm.addCommentForm.likeNum = $$v
      },
      expression: "addCommentForm.likeNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addComment('addCommentForm')
      }
    }
  }, [_vm._v("立即创建")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.clearCommentData()
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "comment-preview-box"
  }, [(_vm.addCommentForm.commentContent !== '' && _vm.addCommentForm.userPortrait !== '') ? _c('div', {
    staticClass: "say-sth"
  }, [_c('div', {
    staticClass: "user"
  }, [_c('img', {
    attrs: {
      "src": _vm.addCommentForm.userPortrait
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.addCommentForm.userName))])]), _vm._v(" "), (_vm.addCommentForm.commentImg !== '') ? _c('img', {
    staticClass: "commentImg",
    attrs: {
      "src": _vm.addCommentForm.commentImg
    }
  }) : _vm._e(), _vm._v(" "), (_vm.addCommentForm.commentContent !== '') ? _c('div', {
    class: [_vm.addCommentForm.commentImg == '' ? 'content' : 'isImg']
  }, [_c('span', [_vm._v(_vm._s(_vm.addCommentForm.commentContent))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "thumbs"
  }, [_c('img', {
    attrs: {
      "src": "http://localhost:8888/topicPK/images/thumbs.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.addCommentForm.likeNum))]), _c('span', [_vm._v(" 赞")])])]) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0a098db1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/topic/Business.vue
// module id = 728
// module chunks = 1